import React, { FC } from 'react';

const FoodoraEmployee: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.212 163.536H65.9638C49.6278 163.536 36.3398 150.248 36.3398 133.912V65.664C36.3398 49.328 49.6278 36.04 65.9638 36.04H134.216C150.552 36.04 163.84 49.328 163.84 65.664V133.916C163.836 150.248 150.548 163.536 134.212 163.536Z"
        fill="#FAF9F6"
      />
      <path
        d="M88.3994 162.192L98.0314 177.688C98.9914 179.232 101.223 179.264 102.231 177.756L113.283 161.176"
        fill="#FAF9F6"
      />
      <path
        d="M132.767 132.158C150.814 114.111 150.814 84.8512 132.767 66.8045C114.72 48.7578 85.4605 48.7578 67.4138 66.8045C49.3671 84.8512 49.3671 114.111 67.4138 132.158C85.4605 150.204 114.72 150.204 132.767 132.158Z"
        fill="white"
      />
      <path
        d="M100.095 140.012C122.481 140.012 140.627 121.865 140.627 99.48C140.627 77.0948 122.481 58.948 100.095 58.948C77.7103 58.948 59.5635 77.0948 59.5635 99.48C59.5635 121.865 77.7103 140.012 100.095 140.012Z"
        fill="#DF1067"
      />
      <path
        d="M108.675 101.578C113.414 96.8386 113.414 89.1546 108.675 84.4152C103.935 79.6759 96.2514 79.6759 91.512 84.4152C86.7727 89.1546 86.7727 96.8386 91.512 101.578C96.2514 106.317 103.935 106.317 108.675 101.578Z"
        fill="white"
      />
      <path
        d="M100.096 108.6C86.8162 108.6 75.8842 118.676 74.5322 131.6C81.5082 137.276 90.4042 140.68 100.096 140.68C109.788 140.68 118.688 137.276 125.66 131.6C124.308 118.676 113.376 108.6 100.096 108.6Z"
        fill="white"
      />
      <path
        d="M117.136 129.004C117.136 119.68 124.692 112.124 134.016 112.124C143.34 112.124 150.896 119.68 150.896 129.004C150.896 138.328 143.34 145.884 134.016 145.884C124.696 145.884 117.136 138.328 117.136 129.004Z"
        fill="#0A4342"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.222 128.904C124.222 127.948 124.996 127.173 125.952 127.173H141.7C142.656 127.173 143.431 127.948 143.431 128.904C143.431 129.86 142.656 130.634 141.7 130.634H125.952C124.996 130.634 124.222 129.86 124.222 128.904Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.823 119.505C134.779 119.505 135.554 120.28 135.554 121.236V136.984C135.554 137.94 134.779 138.714 133.823 138.714C132.868 138.714 132.093 137.94 132.093 136.984V121.236C132.093 120.28 132.868 119.505 133.823 119.505Z"
        fill="white"
      />
    </svg>
  );
};

export default FoodoraEmployee;
